<template>
  <div id="stockdetail">
    <el-row>
      <el-col :span="12">
        <ul>
          <li>客户名称：{{ titleData.GYS_NAME }}</li>
          <li>退库日期：{{ titleData.WAREHOUSE_RETURN_DAY }}</li>
        </ul>
      </el-col>
      <el-col :span="12">
        <ul>
          <li>订单编号：{{ titleData.RETURN_ORDER_CODE }}</li>
          <!-- <li>入库总金额：{{ totalFee }}</li> -->
          <li>退库总金额：{{ titleData.TOTAL_FEE }}元</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="RETURN_COUNT" label="退库数量"></el-table-column>
          <el-table-column prop="PRICE" label="销售价"></el-table-column>
          <el-table-column prop="RETURN_FEE" label="退库金额"></el-table-column>
          <!-- <el-table-column prop="PRODUCT_PRICE" label="入库价"></el-table-column>
          <el-table-column prop="PRODUCT_FEE" label="入库金额"></el-table-column> -->
          <el-table-column prop="RETURN_REASON" label="退库理由"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="margin-top: 20px">
        <el-button @click="toPrintTable">打印退库单</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { salesReturnWarehouseDetailFun } from 'api/returnWare';
import { print } from 'api/warehouseManager';

export default {
  data() {
    return {
      tableData: [],
      titleData: {},
      companyName: '',
    };
  },
  created() {
    this.companyName = sessionStorage.getItem('company');
    this.getRecordDetail();
  },
  methods: {
    // ----------------------拉取数据
    getRecordDetail() {
      const params = {
        SALES_WAREHOUSE_RETURN_ID: Number(this.$route.params.swrid),
      };
      salesReturnWarehouseDetailFun(params)
        .then((result) => {
          this.tableData = result.DATA;
          this.titleData = result.TITLE;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    toPrintTable() {
      let html = '<div>';
      html += '<div class="main">';
      html += `<div class="title">${this.companyName}销售退库单</div>`;
      html += `<div class="head"><div class="code" style="font-size: 20px;">客户：${this.titleData.GYS_NAME}</div><div style="font-size: 20px;">日期：${this.titleData.WAREHOUSE_RETURN_DAY}</div></div>`;
      html += `<div class="head"><div class="code" style="font-size: 20px;">退库单编号：${this.titleData.RETURN_ORDER_CODE}</div><div style="font-size: 20px;">总金额：${this.titleData.TOTAL_FEE}元</div></div>`;
      html += '<table border="1" cellspacing="0"><div class="el-table__body el-table__header">';
      html += '<tr><th style="width: 50px">序号</th> <th>产品</th> <th>单位</th> <th  style="width: 40px">单价</th> <th style="width: 70px">退库数量</th> <th  style="width: 70px">退库金额</th> <th>退货理由</th> </tr>';
      html += '</div><div class="el-table__body">';
      this.tableData.forEach((item, index) => {
        html += '<tr style="text-align: center">';
        html += `<td> ${index + 1} </td> <td>${item.PRODUCT_NAME}</td>  <td>${item.TYPE_UNIT}</td> <td>${item.PRICE}</td>
                 <td>${item.RETURN_COUNT}</td> <td>${item.RETURN_FEE}</td> <td>${item.RETURN_REASON}</td>`;
        html += '</tr>';
      });
      html += '</div>';
      html += '</table>';
      html += '</div>';
      html += '<div style="margin-top: 20px; display: flex; flex-direction: row; font-size: 20px;"><div>退货人：</div><div style="margin-left: 200px; font-size: 20px;">主管：</div></div>';
      html += '</div>';
      const windows = print(html);
      windows.close();
    },
  },
};
</script>
<style scoped>
.footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}

ul {
  list-style: none;
  min-height: 5px;
  padding: 0
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/tableManage/returnWareSupplierCusDetail.vue